import { useState } from "react";

export function CopyButton({ value, label = "Copy" }: { value: string; label?: string }) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard API can be unavailable (permissions/insecure context) — fail silently,
      // the value is still visible/selectable on screen.
    }
  }

  return (
    <button type="button" className="btn btn-secondary btn-sm" onClick={handleCopy}>
      {copied ? "Copied" : label}
      <span className="visually-hidden" aria-live="polite">
        {copied ? "Value copied to clipboard" : ""}
      </span>
    </button>
  );
}
